import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './Breadcrumbs.scss'

export const Breadcrumbs = ({
  items,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <div
      className={classnames('c-breadcrumbs', className)}
      data-mu-test={classnames('breadcrumbs', dataAttributeTest)}
    >
      <ul className='c_breadcrumbs__items'>
        {items.map(
          ({ target, onClick, label, url, route, ...otherProps }, i) => (
            <li key={`breadcrumbs-${i}`} className='c-breadcrumbs__item'>
              {url || route ? (
                <a
                  target={target}
                  onClick={e => typeof onClick === 'function' && onClick(e)}
                  {...otherProps}
                >
                  {label}
                </a>
              ) : (
                <span
                  onClick={e => {
                    typeof onClick === 'function' && onClick(e)
                  }}
                  {...otherProps}
                >
                  {label}
                </span>
              )}
            </li>
          )
        )}
      </ul>
    </div>
  )
}

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      onClick: PropTypes.func,
      target: PropTypes.string
    })
  ),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
